import { render } from "./category.vue?vue&type=template&id=4f102a02&scoped=true&ts=true"
import script from "./category.vue?vue&type=script&lang=ts"
export * from "./category.vue?vue&type=script&lang=ts"

import "./category.vue?vue&type=style&index=0&id=4f102a02&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f102a02"]])

export default __exports__